
export class DateUtils {
    static pad(num: any, size: any) {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    static formatDate(date: any): string {
        return this.pad(date.getDate(), 2) + '.' +
            this.pad(date.getMonth() + 1, 2) + '.' +
            date.getFullYear()
    }

    static formatDateFull(date: any): string {
        return this.pad(date.getDate(), 2) + '.' +
            this.pad(date.getMonth() + 1, 2) + '.' +
            date.getFullYear() + ' ' +
            this.pad(date.getHours(), 2) + ':' +
            this.pad(date.getMinutes(), 2) + ':' +
            this.pad(date.getSeconds(), 2);
    }

    static unixTimestamp(date: any): number {
        return Math.floor(date.getTime() / 1000);
    }
}